import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { ButtonSchema } from '@fhnw/schemas/button';
import { MediaSchema } from '@fhnw/schemas/media';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.CTA),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'media', 'actions', 'contact'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.Title),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    media: {
      title: intl.formatMessage(messages.Media),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_widget',
          widgetProps: {
            schema: MediaSchema({ intl: intl }),
          },
        },
      },
    },
    actions: {
      title: intl.formatMessage(messages.Actions),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: ButtonSchema({ intl: intl }),
          },
        },
      },
    },
    contact: {
      title: intl.formatMessage(messages.Contact),
      description: intl.formatMessage(messages.ContactHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            mode: 'single',
            return: 'single',
            selectableTypes: ['Contact', 'TeamContact'],
          },
        },
      },
    },
  },
  required: [],
});

export default Schema;
